import { toast } from "react-toastify";
import { axiosInstance } from "../api/axios";
import { ApiResponse } from "../models/ApiResponse";
import { SettingsResponse } from "../models/SettingsResponse";

export const getSettings = async () => {
  const result = await axiosInstance.get<ApiResponse<SettingsResponse>>("configuration/webapp");
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }
  return null;
};
